'use strict';
var React = require('react');
var assetsHelper = require('../../helper/assetsHelper');
var styleHelper = require('../../helper/styleHelper');
var graphicsHelper = require('../../helper/graphicsHelper');
var util = require('../../helper/util');


var LineChart = React.createClass({

  itemNum : 0,

  parseText: function() {

    var lines = util.Text.delimitText(util.Text.removeLastEmptyRow(styleHelper.getText(this.props)), util.Text.DM_RETURN);
    var result = [];

    for(var i=0;i<lines.length;i++) {
      var item = {
        points: undefined,
        color: 'rgba(0,0,0,1)'
      };
      var datas = lines[i].split(/,|，/);
      var points = [];
      if(datas.length-2 > this.itemNum) {
        this.itemNum = datas.length - 2;
      }
      for(var j=0;j<datas.length-1;j++) {
        var n = 0;
        if(datas[j] === '-') {
          n = -1;
        }
        else if(parseFloat(datas[j])) {
          n = parseFloat(datas[j]);
          if(n > 100) {
            n = 100;
          }
          if(n < 0) {
            n = 0;
          }
        }
        points.push(n);
      }
      item.points = points;

      var colorStr = graphicsHelper.tranColor(datas[datas.length-1].trim());
      if(colorStr === "empty") {
        colorStr = "ff000000"
      }
      item.color = graphicsHelper.toRGBA(colorStr);
      result.push(item);
    }

    return result;
  },

  fillCanvas: function() {

    var canvas = ReactDOM.findDOMNode(this.refs.canvas);
    var context = canvas.getContext('2d');

    var width = Math.round(canvas.width * 0.9);
    var height = Math.round(canvas.height * 0.9);
    var offset = Math.round(canvas.height * 0.1);

    var result = this.parseText();

    for(var i=0;i<result.length;i++) {
      var item = result[i];
      var points = item.points;
      if(points.length > 0) {
        var itemWidth = Math.round(width / this.itemNum);
        context.beginPath();
        context.strokeStyle = item.color;
        var beginY = points[0];
        var beginX = 0;
        if(points[0] === -1 && points.length > 1) {
          beginX = itemWidth;
          beginY = points[1];
        }
        context.moveTo(beginX, Math.round(height-height*0.9*beginY/100+offset));
        for(var j=1;j<points.length;j++) {
          if(points[j] === -1) {
            continue;
          }
          context.lineTo(itemWidth*j, Math.round(height-height*0.9*points[j]/100+offset));
        }
        context.stroke();
      }

    }

  },

  componentDidMount: function () {
    this.fillCanvas();
  },

  componentDidUpdate: function () {
    this.fillCanvas();
  },


  render: function () {
    var style = styleHelper.StyleUtil(this.props).size().style;

    return (
      <div className="component-SimpleCom">
        <canvas ref="canvas" width={style.width} height={style.height} >
          浏览器不支持canvas
        </canvas>
        <div className="component-Chart-Coord"></div>
      </div>
    )
  }
});

module.exports = LineChart;



// WEBPACK FOOTER //
// ./src/views/Components/LineChartEx.jsx